class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.inert = true;
    this.addEventListener('click', (event) => { if (event.target.id === 'CartDrawer-Overlay') this.close(); });
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.inert = false;
    this.classList.add('animate', 'active');
    const focusElement = this.querySelector('.drawer__inner');
    trapFocus(focusElement, focusElement);
    this.dispatchEvent(new CustomEvent('wbd:cart_drawer_open', { bubbles: true }));
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    this.inert = true;
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, { open = true } = {}) {
    const sections = this.getSectionsToRender().map((section) => {
      const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      const source = this.getSectionDOM(parsedState.sections?.[section.id], section.selector || '.shopify-section');
      if (!target || !source) throw new Error('Cart sections ontbreken.');
      return { target, source };
    });
    sections.forEach(({ target, source }) => { target.innerHTML = source.innerHTML; });
    this.classList.toggle('is-empty', !!this.querySelector('.drawer__inner-empty'));
    if (open || this.classList.contains('active')) this.open();
  }

  showFeedback(message, state = 'error') {
    let error = this.querySelector('#CartDrawer-CartErrors');
    if (!error) {
      error = document.createElement('p');
      error.id = 'CartDrawer-CartErrors';
      error.setAttribute('role', 'alert');
      this.querySelector('.drawer__inner').append(error);
    }
    error.dataset.feedbackState = state;
    error.setAttribute('role', state === 'error' ? 'alert' : 'status');
    error.setAttribute('aria-atomic', 'true');
    error.textContent = message;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return html ? new DOMParser().parseFromString(html, 'text/html').querySelector(selector) : null;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
